import { copyMmsToUserDocAsync } from "api/document";

/**
 * Copy an existing S3 object from the MMS bucket to the user-doc bucket via the
 * an-api backend (no direct AWS access in the browser). Buckets are resolved
 * server-side, so callers only provide the source and destination keys.
 *
 * Legacy `sourceBucket`/`destinationBucket` args are accepted but ignored — the
 * backend always copies MMS → user-doc.
 *
 * @param {Object} options
 * @param {string} options.sourceKey - Key of the existing file in the MMS bucket
 * @param {string} options.destinationKey - New key in the user-doc bucket
 */
export const copyS3Object = async ({ sourceKey, destinationKey }) => {
  if (!sourceKey || !destinationKey) {
    throw new Error("sourceKey and destinationKey are required");
  }

  const response = await copyMmsToUserDocAsync({ sourceKey, destinationKey });
  return response.data;
};
